/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

import { pd, getColor } from '@airasia-phoenix/react-native/utils/utils';

export const BOTTOM_SHEET_LAYOUT = {
  DEFAULT_HEIGHT: 400,
  SCROLL_HEIGHT_RATIO: 0.9,
  DEFAULT_FOOTER_HEIGHT: 110,
  BG_COLOR: getColor(pd.sys.colour.bg_primary),
} as const;

export const BOTTOM_SHEET_SPACING = {
  HORIZONTAL: pd.ref.space.spacing20.px,
  BOTTOM: 0,
  TOP: pd.ref.space.spacing10.px,
  FOOTER_PADDING: 0,
} as const;
